<template>
	<v-row
		align='center'
		align-content='center'
		class='text-center ml-1'
		justify='center'
	>

		<v-col class='text-center pl-0'>
			<v-row v-if='defaultTile !== null' no-gutters style='width: 100%; margin-bottom: 10px'>
				<v-col
					:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
					class='text-center'
					:cols='$vuetify.breakpoint.xsOnly ? 12 : 6'
					md='4'
				>

					<v-btn
						:depressed='selectedTiles.includes(defaultTile)'
						:outlined='!selectedTiles.includes(defaultTile)'
						block
						:small='$vuetify.breakpoint.mdAndDown'
						class='select_btn light-border br-3'
						color='primary'
						@click='tileClicked(defaultTile)'
					>
						{{ defaultTile.label }}
					</v-btn>

				</v-col>
			</v-row>
			<v-row
				align-content='center'
				class='px-3 flex-grow-0'
			>
				<v-col
					v-for='tile in tiles'
					:key='tile.id'
					class='flex-grow-0'
					style='padding:0'
					:cols='isXss ? 6 : $vuetify.breakpoint.xsOnly ? 4 : 2'
				>
					<div
						class='category light-border ma-1'
						:style='{borderColor: selectedTiles.indexOf(tile) !== -1 ? $vuetify.theme.themes.light.green + " !important" : ""}'
						@click='tileClicked(tile)'
					>
						<v-icon
							v-if='selectedTiles.includes(tile)'
							color='green'
							class='check'
							dark
							style='z-index: 33'
							size='22px'
						>
							fas fa-check-circle
						</v-icon>


						<v-img
							:src='tile.image'
							class='tile-img'
							height='68px'
							width='100px'
							contain
						>
							<template v-slot:placeholder>
								<v-row
									align='center'
									class='fill-height ma-0'
									justify='center'
								>
									<v-progress-circular color='primary lighten-4' indeterminate width='4' />
								</v-row>
							</template>
						</v-img>

						<div class='tile-title'>
							{{ tile.label }}
						</div>
					</div>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import BaseFilterMixin from './BaseFilterMixin'

export default {
  name: 'CategoryFilter',
  mixins: [BaseFilterMixin],

  data: () => ({
    selectedTiles: [],
    windowWidth: 0
  }),

  computed: {
    isXss() {
      return this.windowWidth < 400
    },
    tiles() {
      return this.filter.values.filter(t => {
        return t !== this.defaultTile
      })
    },
    defaultTile() {
      return this.filter.values.find(t => {
        return t.default
      })
    }
  },
  watch: {
    selectedTiles: {
      deep: true,
      handler() {
        this.updateFilter(this.selectedTiles)
      }
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  mounted() {
    this.selectDefaultTile()
    this.$bus.$on('v-menu-open:'+this.filter.name, async () => {
        await this.$nextTick();
        this.selectDefaultTile()
    })
    this.onResize();
    window.addEventListener('resize', this.onResize)
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
    selectDefaultTile () {
      if (this.filter.selectedValues && this.filter.selectedValues.length) {
        this.selectedTiles = this.filter.selectedValues
      } else {
        this.selectedTiles.push(this.defaultTile)
      }
    },
    tileClicked(tile) {
      const index = this.selectedTiles.indexOf(tile)
      const defaultTileIndex = this.selectedTiles.indexOf(this.defaultTile)
      if (tile === this.defaultTile) {
        // remove all items and add default option
        this.selectedTiles = [];
        this.selectedTiles.push(tile)
      } else if (defaultTileIndex !== -1) {
        // remove default option if an item is selected
        this.selectedTiles.splice(defaultTileIndex, 1)
        this.selectedTiles.push(tile)
      } else {
        // just add the option to the selection
        if (index === -1) {
          this.selectedTiles.push(tile)
        } else {
          // remove the option from the selection
          this.selectedTiles.splice(index, 1)
          if (this.selectedTiles.length === 0) this.selectedTiles.push(this.defaultTile)
        }
      }
    }
  }
}
</script>

<style scoped>
.category {
  box-sizing: content-box;
  height: 106px;
  width: 108px;
  position: relative;
  border-width: 2px !important;
}

.check {
  position: absolute;
  right: 4px;
  top: 4px;
}

.tile-img {
  box-sizing: border-box;
  margin: 4px;
}

.default-tile-title, .tile-title {
  font-size: 13.5px !important;
  width: 106px;
  margin-left: 1px;
  text-align: center;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}

.default-tile-title {
  height: 100%;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.tile-title {
  height: 32px;
  line-height: 32px;
}
.category:hover {
  background-color: rgba(10, 10, 20, 0.04);
  cursor: pointer
}
</style>
